import { isAxiosError } from 'axios';
import { ErrorSchema, ErrorSchemaBuilder } from '@rjsf/utils';
import { UnprocessableEntityErrorResponse } from 'api/model';

const MAX_LENGTH = 255;
const MAX_DEPTH = 5;
const SEGMENT_PATTERN = /^[\p{L}\p{N} \-_]+$/u;

export const normalizeFolderPath = (raw?: string | null): string => (raw ?? '').trim().replace(/^\/+|\/+$/g, '');

export const validateFolderPath = (raw?: string | null): string | null => {
  const path = normalizeFolderPath(raw);
  if (path === '') return null;

  if (path.length > MAX_LENGTH) {
    return `Folder path must be at most ${MAX_LENGTH} characters`;
  }

  const segments = path.split('/');
  if (segments.length > MAX_DEPTH) {
    return `Folder path can be at most ${MAX_DEPTH} levels deep`;
  }

  for (const segment of segments) {
    if (segment.trim() === '') {
      return 'Folder path cannot contain empty segments';
    }
    if (segment === '.' || segment === '..') {
      return 'Folder path cannot contain "." or ".." segments';
    }
    if (!SEGMENT_PATTERN.test(segment)) {
      return 'Folder path may only contain letters, digits, spaces, hyphens and underscores';
    }
  }

  return null;
};

export const getFolderPathServerError = (error: unknown): string | null => {
  if (!isAxiosError<UnprocessableEntityErrorResponse>(error) || error.response?.status !== 422) {
    return null;
  }

  const detail = error.response?.data?.detail;
  if (!Array.isArray(detail)) return null;

  const folderError = detail.find((d) => d.loc?.some((part) => part === 'folder_path'));
  return folderError?.msg ?? null;
};

export const folderExtraErrors = (folderError: string | null): ErrorSchema | undefined =>
  folderError ? new ErrorSchemaBuilder().addErrors([folderError], 'folder_path').ErrorSchema : undefined;
